
const template = document.createElement("template");
template.innerHTML = `
<style>
:host {
  position: relative;
  display: block;
  cursor: pointer;
}
#container {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 0 0 6px 6px;
    padding: 8px 0;
    position: absolute;
    z-index: 3;
    top:0
    left: 0%;
    margin-left: 0px;
    -webkit-animation: fadeIn 1s;
    animation: fadeIn 1s;
    background-color: white;
}
</style>
<div id="container"><slot></slot></div>
`;

export class OverlayElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;

    constructor() {
        super();
    }

    public appendChild<T extends Node>(newChild: T): T {
        let nested = this.getAttribute("nested-tree");
        if (nested == null) {
            return super.appendChild(newChild);
        } else {
            super.appendChild(template.content.cloneNode(true));
            return this.querySelector("#container").appendChild(newChild);
        }
    }

    private connectedCallback() {
        let nested = this.getAttribute("nested-tree");
        if (nested == null) {
            this._shadowRoot = this.attachShadow({ mode: "open" });
            this._shadowRoot.appendChild(template.content.cloneNode(true));
        }
        setTimeout(() => document.addEventListener("click", this.documentClickCallback), 0);
    }

    private documentClickCallback = (evt) => {
        if (!evt.composedPath().includes(this)) {
            this.parentNode.removeChild(this);
        }
    }

    private disconnectedCallback() {
        document.removeEventListener("click", this.documentClickCallback);
    }
}

export function initOverlayWebComponent() {
    window.customElements.define("s6-overlay", OverlayElement);
}
